import React from 'react'
import { authRoles } from '../../../auth/authRoles'
import WarrantyView from './WarrantyView'
import Warranties from './Warranties'
import WarrantyForm from './WarranyForm'
import WarrantyActivation from './WarrantyActivation'

const warrantyRoutes = [
    {
        path: '/warranties/view/:uuid',
        element: <WarrantyView />,
        auth: authRoles.admin,
    },
    {
        path: '/warranties/edit/:uuid',
        element: <WarrantyForm />,
        auth: authRoles.admin,
    },
    {
        path: '/warranties/add',
        element: <WarrantyActivation />,
        auth: authRoles.admin,
    },
    {
        path: '/warranties',
        element: <Warranties />,
        auth: authRoles.admin,
    },
]

export default warrantyRoutes
